<template>
  <div class="checkout" v-if="Object.keys(this.booking_data).length">
    <!-- nel js c'è un router push a 'detail' se non trovo booking_data (es. se refresho la pagina checkout). questo ulteriore controllo è per evitare un undefined rischioso a template -->
    <b-container v-if="!(loading || purchasing)" class="checkout__content">
      <button-back :forwards_only="forwards_only" />
    </b-container>
    <b-container class="checkout__content">
      <section v-if="loading" class="section section--loader">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <b-row>
        <b-col sm="12" md="7" lg="8" xl="9">
          <div v-if="!loading">
            <div v-if="!checkout_ok">
              <div class="checkout--panel" compact>
                <flight-pad-details :flight_offer="flight_offer" collapsed />
              </div>
              <additional-services-booked
                :flight_offer="flight_offer"
                :travelers="traveler_details"
              />
              <content-section
                title="I contatti a cui riceverai le informazioni sul tuo volo"
              >
                <template>
                  <div
                    v-for="(contact, index) in booking_data
                      .flightCreateOrderBody.data.contacts"
                    v-bind:key="_uid + index"
                  >
                    <div class="checkout--user-info">
                      <traveler-icon
                        :traveler="traveler_details[0]"
                        :size="16"
                        :color="sass('dark')"
                      />
                      {{ contact.addresseeName.firstName }}
                      {{ contact.addresseeName.middleName }}
                      {{ contact.addresseeName.lastName }}
                    </div>
                    <div class="checkout--user-info" style="margin-left: 4px">
                      <vb-icon name="email" :size="16"></vb-icon>
                      {{ contact.emailAddress }}
                    </div>
                    <div class="checkout--user-info">
                      <vb-icon name="mobile" :size="16"></vb-icon>
                      +{{ contact.phones[0].countryCallingCode }}
                      {{ contact.phones[0].number }}
                    </div>
                    <hr
                      v-if="
                        index <
                        booking_data.flightCreateOrderBody.data.contacts
                          .length -
                          1
                      "
                    />
                  </div>
                </template>
              </content-section>
              <content-section
                title="Elenco dei passeggeri"
                description="Verifica che nomi e date di nascita siano corrispondenti a
                  quelli riportati nel documento di identità con cui verrà fatto
                  l'imbarco"
              >
                <template>
                  <div
                    v-for="(traveler, index) in booking_data
                      .flightCreateOrderBody.data.travelers"
                    v-bind:key="_uid + index"
                  >
                    <div class="checkout--user-info">
                      <traveler-icon
                        :traveler="traveler_details[index]"
                        :size="16"
                        :color="sass('dark')"
                      />
                      <span>
                        {{ traveler.name.firstName }}
                        {{ traveler.name.middleName }}
                        {{ traveler.name.lastName }}
                      </span>
                      <span style="font-size: 30px; line-height: 0">
                        &middot;
                      </span>
                      <span>{{ reverse_date(traveler.dateOfBirth) }}</span>
                    </div>
                  </div>
                </template>
              </content-section>
            </div>
            <div v-else class="checkout--panel" compact>
              <p v-if="checkout_msg">
                <b-alert variant="success" v-html="checkout_msg" show />
              </p>
              <!--<p>
                                <b>codice di conferma</b>: {{ checkout_confirmcode }}
                            </p>-->
            </div>
          </div>
        </b-col>
        <b-col m="12" md="5" lg="4" xl="3">
          <sidebar
            :integration="integration"
            :availability="sidebar_availability"
            :live_price="live_price"
            :loading="loading"
            :purchasing="purchasing"
            :completed="checkout_ok"
            :discount_codes="discount_codes"
            @purchase="
              (sidebar_data) => {
                purchase(sidebar_data);
              }
            "
            @commit="
              (event) => {
                this.$store.commit(event.name, event.payload);
              }
            "
          >
            <template #resume>
              <sidebar-resume :flight_offers="[flight_offer]" contained />
            </template>

            <template #message>
              <div v-if="checkout_ok" class="vb-sidebar__block">
                <div v-if="checkout_msg" v-html="checkout_msg"></div>
              </div>
              <div v-if="!checkout_ok && purchasing" class="text-center">
                <loader />
              </div>
            </template>
          </sidebar>
        </b-col>
      </b-row>

      <loader-modal :show="!checkout_ok && purchasing" service="book" />
    </b-container>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import {
  book,
  retrieve,
  get_offer_details,
  has_capability_for,
} from "@liveflight/providers";
import { parse_flight_offer_for_ecommerce_item } from "@liveflight/utilities/mixins";
import { get_markup } from "@liveflight/utilities/price";
import {
  reverse_date,
  custom_event,
  get_availability,
  log,
} from "@/utilities/commons";
import FlightPadDetails from "@liveflight/components/blocks/flight-pad/flight-pad-details/flight-pad-details";
import SidebarResume from "@liveflight/components/blocks/resume/resume";
import ContentSection from "@liveflight/components/blocks/wrappers/content-section.vue";
import Sidebar from "@components/blocks/sidebar/sidebar";
import AdditionalServicesBooked from "@liveflight/components/blocks/additional-services-booked.vue";
import TravelerIcon from "@liveflight/components/blocks/traveler/traveler-icon.vue";

export default {
  name: "checkout",
  components: {
    "additional-services-booked": AdditionalServicesBooked,
    "content-section": ContentSection,
    "flight-pad-details": FlightPadDetails,
    "sidebar-resume": SidebarResume,
    sidebar: Sidebar,
    "traveler-icon": TravelerIcon,
  },
  props: {},
  data() {
    return {
      vm: this,
      loading: true,
      purchasing: false,
      integration: Vue.prototype.$config.integration,
      checkout_ok: false,
      checkout_msg: "",
    };
  },
  computed: {
    ...mapState(["discount_codes", "booking_data"]),
    ...mapState("liveflight", [
      "flight_offer",
      "traveler_details",
      "contact_details",
      "guests",
      "held_booking",
    ]),
    live_price() {
      return this.booking_data.live_price || "0";
    },
    forwards_only() {
      return has_capability_for(this.flight_offer, "forwardsOnly");
    },
    sidebar_availability() {
      return get_availability(this.live_price);
    },
  },
  created() {
    this.reverse_date = reverse_date;
    this.custom_event = custom_event;
    // se non trovo booking data rimando al dettaglio
    if (!Object.keys(this.booking_data).length) {
      this.$router.replace("detail");
      return;
    }

    // per evitare undefined quando li popolo dinamicamente
    if (this.booking_data.payments == undefined) {
      this.booking_data.payments = {
        cc: {},
        welfare: {},
        discountCodes: {},
      };
    }
  },
  mounted() {
    custom_event("initiateCheckout", this.flight_offer.price.grandTotal);

    let item = parse_flight_offer_for_ecommerce_item(this.flight_offer);

    custom_event({
      event: "begin_checkout",
      ecommerce: {
        currency: "EUR",
        items: [item],
        transaction_id: "",
        affiliation: "",
        value: item.price,
        tax: 0,
        shipping: 0,
        coupon: "",
      },
    });
    custom_event({
      event: "add_to_cart",
      ecommerce: {
        currency: "EUR",
        items: [item],
        transaction_id: "",
        affiliation: "",
        value: item.price,
        tax: 0,
        shipping: 0,
        coupon: "",
      },
    });

    this.refresh_offer()
      .then((flight_offer) => {
        if (!flight_offer) {
          log("checkout.refresh missing offer");
          window.eventBus.$emit("got_toast_notification", {
            text: "Non siamo riusciti ad aggiornare il riepilogo: i totali mostrati potrebbero non essere aggiornati.",
            variant: "warning",
          });
          return;
        }
        this.$store.commit("liveflight/flight_offer", flight_offer);
        this.$store.commit("booking_data", {
          ...this.booking_data,
          live_price: get_markup(flight_offer).mu_price,
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    refresh_offer() {
      // ancillariesAsStep providers: re-pull the held booking so totals
      // reflect what book_ancillaries committed before unblocking the page.
      const should_retrieve =
        has_capability_for(this.flight_offer, "ancillariesAsStep") &&
        this.held_booking &&
        this.held_booking.id;

      if (should_retrieve) {
        return retrieve(this.flight_offer, this.held_booking.id).then(
          ({ flight_offer }) => flight_offer,
        );
      }
      return get_offer_details(this.flight_offer);
    },
    purchase(sidebar_data) {
      // I pagamenti sono già preparati dalla sidebar generica
      this.booking_data.payments = sidebar_data.payments;

      // Prepara i dati guest dal payload della sidebar
      const guestPayload =
        (sidebar_data.guest && sidebar_data.guest.payload) || {};
      const guests = {
        guestFirstName: guestPayload.guestFirstName,
        guestLastName: guestPayload.guestLastName,
        guestFiscalCode: guestPayload.guestFiscalCode,
        guestEmail: guestPayload.guestEmail,
        guestEmailConf: guestPayload.guestEmailConf,
        guestPrivacy: guestPayload.guestPrivacy,
        beneficiaryId: guestPayload.beneficiaryId || 0,
      };
      if (guestPayload.guestPhone) {
        guests.guestPhone = guestPayload.guestPhone;
      }
      this.$store.commit("liveflight/guests", guests);

      this.loading = true;
      this.purchasing = true;
      this.scroll_top();

      book(this.flight_offer, {
        travelers: this.traveler_details,
        contact: this.contact_details,
        payments: this.booking_data.payments,
        guest: this.guests,
        heldBooking: this.held_booking,
        livePrice: this.booking_data.live_price,
      }).then(
        (success) => {
          this.scroll_top();
          const { status = 500, data = {} } = success || {};
          this.checkout_msg = data.msg;
          this.loading = false;
          this.purchasing = false;

          // 202 = asyncPayment in flight; not a finalized success.
          if (status === 202) {
            this.checkout_ok = true;
            return;
          }

          // Envelope-level error: BE returned 200 but with `data.errors`.
          if (data.errors) {
            custom_event("checkoutError");
            return;
          }

          this.checkout_ok = true;
          const {
            confirmcode: confirmCode,
            updateAvailabilityTo,
            flightVoucherId,
            kyteVoucherId,
          } = data;
          custom_event("confirmedCheckout", this.flight_offer.price.grandTotal);

          const item = parse_flight_offer_for_ecommerce_item(this.flight_offer);
          custom_event({
            event: "purchase",
            ecommerce: {
              currency: "EUR",
              items: [item],
              transaction_id: confirmCode,
              affiliation: "",
              value: item.price,
              tax: 0,
              shipping: 0,
              coupon: "",
            },
          });
          if (updateAvailabilityTo) {
            Vue.prototype.$config.integration.availability =
              updateAvailabilityTo;
          }

          const resolved = this.$router.resolve({
            name: "confirm",
            params: {
              flight_voucher_id: flightVoucherId || kyteVoucherId,
              confirm_code: confirmCode,
            },
          });
          window.location.href = resolved.href;
        },
        (error) => {
          log("checkout.purchase", error);
          this.loading = false;
          this.purchasing = false;
          custom_event("checkoutError");
        },
      );
    },
  },
};
</script>

<style lang="scss">
.checkout {
  &--panel {
    @extend .content-panel !optional;
    margin-bottom: 1rem !important;
  }
  &--user-info {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 0.25rem;
  }
  .privacy-box {
    display: flex;
  }
  .btn-light {
    .chevron svg {
      width: 10px;
      height: auto;
      path {
        stroke: $cta;
      }
    }
  }

  &__content {
    padding-top: $grid-gutter-width;
  }
}
</style>
